export { default } from './FinesEmptyContentPanel';



// WEBPACK FOOTER //
// ./app/components/borrowing/fines/FinesEmptyContentPanel/index.js